module.exports = __webpack_public_path__ + "components/flag/static/square/rs-09a864ddd4fa40094ad1954dc8f3f784.svg";